"use client";

import {
  ChartCandlestick,
  HelpCircle,
  House,
  Zap,
} from "lucide-react";
import React from "react";
import { useRouter, usePathname } from "next/navigation";
import { motion } from "framer-motion";

export default function MenuBar() {
  const router = useRouter();
  const pathname = usePathname();

  const links = [
    { label: "Inicio", icon: House, path: "/inicio" },
    { label: "Acelerador", icon: Zap, path: "/accelerator" },
    { label: "Invertir", icon: ChartCandlestick, path: "/trade" },
    { label: "Ayuda", icon: HelpCircle, path: "/help" },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-150 pb-safe">
      <div className="max-w-md w-full mx-auto flex items-center justify-around py-2 px-4">
        {links.map(({ label, icon: Icon, path }) => {
          // Considera /inicio e / como a mesma página para isActive
          const isActive = pathname === path || (path === "/inicio" && pathname === "/");

          return (
            <motion.div
              key={label}
              whileTap={{ scale: 0.95 }}
              className={`flex flex-col items-center gap-1 cursor-pointer transition-all min-w-[60px] py-2 px-3 rounded-xl ${
                isActive 
                  ? "bg-blue-50" 
                  : "hover:bg-gray-50"
              }`}
              onClick={() => {
                // Força reload para Inicio e Trade (resolve VTurb e atualiza estado)
                if (path === "/inicio" || path === "/trade") {
                  window.location.href = path;
                } else {
                  router.push(path);
                }
              }}
            >
              <div className={`transition-all ${
                isActive 
                  ? "bg-gradient-to-br from-blue-500 to-blue-600 p-2 rounded-xl shadow-lg shadow-blue-500/30" 
                  : "p-2"
              }`}>
                <Icon className={`w-5 h-5 transition-colors ${
                  isActive 
                    ? "text-white" 
                    : "text-gray-400"
                }`} />
              </div>
              <span className={`text-xs font-medium transition-colors ${
                isActive 
                  ? "text-blue-600" 
                  : "text-gray-400"
              }`}>
                {label}
              </span>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
